exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-containers-users-Details-___style__image___77Q5Q {\n  max-height: 320px; }\n", ""]);

// exports
exports.locals = {
	"image": "src-containers-users-Details-___style__image___77Q5Q"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./node_modules","./node_modules/grommet/node_modules"]}!./src/containers/users/Details/style.scss
// module id = 456
// module chunks = 0